/** The mark a fabricated scenario wears wherever it shows. A past ticket is the default and wears none. */

import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { ScenarioKind } from '@/types/websocket.types';

export const KindBadge = ({ kind, className }: { kind: ScenarioKind | null | undefined; className?: string }) =>
	kind === 'fabricated' ? (
		<Badge variant='outline' className={cn('border-violet-200 bg-violet-50 text-[10px] text-violet-700', className)}>
			Fabricated
		</Badge>
	) : null;
